module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/4d89d58309c13d68fae3a79c7e99a77f.png";